import {defineStyle, defineStyleConfig} from '@chakra-ui/react'

const outline = defineStyle({
  bg: 'transparent',
  borderColor: 'pg50',
  _hover: {
    bg: 'pg50',
    color: 'white',
    border: 'pg50',

    _disabled: {
      bg: 'pg80',
      borderColor: 'pg80',
    },
  },
})
const destructive = defineStyle({
  bg: 'sr70',
  borderColor: 'sr70',
  _hover: {
    bg: 'sr90',
    color: 'white',
    border: 'sr90',
  },
})
const cta = defineStyle({
  bg: 'pr70',
  borderColor: 'pr70',
  _hover: {
    bg: 'pr80',
    color: 'white',
    border: 'pr80',
  },
})
const dark = defineStyle({
  bg: 'white',
  color: 'pb100',
  borderColor: 'white',
  _hover: {
    bg: 'pb40',
    color: 'pb100',
    border: 'pb40',
    _disabled: {
      bg: 'pb40',
      borderColor: 'pb40',
    },
  },
})

const darkOutline = defineStyle({
  backgroundColor: 'transparent',
  borderColor: 'white',
  _hover: {
    backgroundColor: 'pb60',
    color: 'white',
    _disabled: {
      bg: 'transparent',
      borderColor: 'white',
    },
  },
})

const lg = defineStyle({
  fontSize: '1.25rem',
  minW: '7rem',
  minH: '4rem',
})

const sm = defineStyle({
  fontSize: '1rem',
  minW: '5.6875rem',
  minH: '3rem',
})

const xs = defineStyle({
  fontSize: '0.875rem',
  minW: '4.8125rem',
  minH: '2.5rem',
})

const md = defineStyle({
  fontSize: '1.125rem',
  minW: '6.625rem',
  minH: '3.5rem',
})

const input = defineStyle({
  fontSize: '0.875rem',
  minW: '3.4375rem',
  minH: '1.875rem',
  color: 'black',
  bg: 'pg10',
  _hover: {bg: 'pg30', border: 'none'},
})

export const ButtonStyles = defineStyleConfig({
  baseStyle: {
    bg: 'pb60',
    color: 'white',
    borderRadius: '4px',
    _hover: {
      bg: 'pb80',
      _disabled: {
        bg: 'pb80',
      },
    },

    _focus: {
      outlineColor: 'pb40',
      outlineWidth: '4px',
    },
  },

  sizes: {xs, sm, md, lg, input},
  variants: {
    base: {},
    outline,
    destructive,
    cta,
    dark,
    darkOutline,
    secondary: {},
  },
  defaultProps: {
    variant: 'base',
  },
})
